const API_BASE = process.env.REACT_APP_API_URL || "/api";

export async function apiRequest(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
    body: options.body && typeof options.body !== "string" ? JSON.stringify(options.body) : options.body,
  });
  const payload = response.status === 204 ? null : await response.json().catch(() => null);
  if (!response.ok) throw new Error(payload?.message || payload?.error || `Serverfehler (${response.status})`);
  return payload;
}

export const authApi = {
  me: () => apiRequest("/auth/me"),
  login: (email, password) => apiRequest("/auth/login", { method: "POST", body: { email, password } }),
  register: data => apiRequest("/auth/register", { method: "POST", body: data }),
  logout: () => apiRequest("/auth/logout", { method: "POST" }),
  forgotPassword: email => apiRequest("/auth/forgot-password", { method: "POST", body: { email } }),
  resetPassword: (token, password) => apiRequest("/auth/reset-password", { method: "POST", body: { token, password } }),
};

export const usersApi = {
  list: () => apiRequest("/users"),
  get: id => apiRequest(`/users/${id}`),
  update: (id, data) => apiRequest(`/users/${id}`, { method: "PATCH", body: data }),
  remove: id => apiRequest(`/users/${id}`, { method: "DELETE" }),
  createPasswordResetLink: id => apiRequest(`/users/${id}/password-reset-link`, { method: "POST" }),
  seasonReset: () => apiRequest("/users/season-reset", { method: "POST" }),
};

export const bookingsApi = {
  list: () => apiRequest("/bookings"),
  create: data => apiRequest("/bookings", { method: "POST", body: data }),
  remove: id => apiRequest(`/bookings/${id}`, { method: "DELETE" }),
};

export const seriesApi = {
  list: () => apiRequest("/series"),
  create: data => apiRequest("/series", { method: "POST", body: data }),
  remove: id => apiRequest(`/series/${id}`, { method: "DELETE" }),
};

export const matchesApi = {
  list: () => apiRequest("/matches"),
  create: data => apiRequest("/matches", { method: "POST", body: data }),
  update: (id, data) => apiRequest(`/matches/${id}`, { method: "PATCH", body: data }),
  saveBookingResult: (bookingId, sets) => apiRequest(`/bookings/${bookingId}/result`, { method: "PUT", body: { sets } }),
};
